import { CalendarClock } from 'lucide-react';
import { cn } from '@/lib/utils';
import { formatDate } from '@/utils/formatters';

interface InformationAsOfLabelProps {
  /** ISO date string (YYYY-MM-DD) of the information currency, or null. */
  date: string | null | undefined;
  className?: string;
}

/**
 * Render information as of date
 * e.g. "Information as of 02/06/2026".
 *
 * Renders nothing when no date is available.
 */
export function InformationAsOfLabel({
  date,
  className,
}: InformationAsOfLabelProps) {
  if (!date) {
    return null;
  }

  return (
    <p
      className={cn(
        'flex items-center gap-1.5 text-sm text-muted-foreground',
        className
      )}
    >
      <CalendarClock className="h-3.5 w-3.5" aria-hidden="true" />
      <span>Information as of {formatDate(date)}</span>
    </p>
  );
}